import React, { useState, useEffect,useMemo} from 'react';
import {
  Box,
  Container,
  Paper,
  Avatar,
  Typography,
  TextField,
  Button,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Divider,
  Breadcrumbs,
  Card,
  CardContent,
  styled,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';
import {
  Edit as EditIcon,
  ArrowBack as ArrowBackIcon,
  Person as PersonIcon,
  PhotoCamera as PhotoCameraIcon,
  Save as SaveIcon,
  Close as CloseIcon,
  Phone as PhoneIcon,
  Public as PublicIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import S3FileUpload from 'react-s3';
import AWS from 'aws-sdk';
import { CustomerUpdateProfile } from "./action/auth";
import { useAuthToken } from "../TokenContext";
import { useCredentials } from '../useCredentials';
import defaultimg from './assets/defaultimge.png';
import { useTheme } from '@mui/material';
import './controlplane/ArtemyStyles.css';
// AWS Configuration


 const countries = [ { value: 'usa', label: 'USA' },
  { value: 'canada', label: 'Canada' },
  { value: 'india', label: 'India' },
  { value: 'australia', label: 'Australia' },
  { value: 'united_kingdom', label: 'United Kingdom' },
  { value: 'germany', label: 'Germany' },
  { value: 'france', label: 'France' },
  { value: 'china', label: 'China' },
  { value: 'japan', label: 'Japan' },
  { value: 'brazil', label: 'Brazil' },
  { value: 'south_africa', label: 'South Africa' },
  { value: 'mexico', label: 'Mexico' },
  { value: 'italy', label: 'Italy' },
  { value: 'spain', label: 'Spain' },
  { value: 'russia', label: 'Russia' },
  { value: 'south_korea', label: 'South Korea' },
  { value: 'new_zealand', label: 'New Zealand' },
  { value: 'singapore', label: 'Singapore' },
  { value: 'united_arab_emirates', label: 'United Arab Emirates' },
  { value: 'saudi_arabia', label: 'Saudi Arabia' },
  { value: 'argentina', label: 'Argentina' },
  { value: 'netherlands', label: 'Netherlands' },
  { value: 'sweden', label: 'Sweden' },
  { value: 'switzerland', label: 'Switzerland' },
  { value: 'norway', label: 'Norway' },
  { value: 'denmark', label: 'Denmark' },
  { value: 'finland', label: 'Finland' },
  { value: 'portugal', label: 'Portugal' },
  { value: 'poland', label: 'Poland' },
  { value: 'turkey', label: 'Turkey' },
  { value: 'indonesia', label: 'Indonesia' },
  { value: 'malaysia', label: 'Malaysia' },
  { value: 'thailand', label: 'Thailand' },
  { value: 'vietnam', label: 'Vietnam' },
  { value: 'philippines', label: 'Philippines' },
  { value: 'egypt', label: 'Egypt' },
  { value: 'nigeria', label: 'Nigeria' },
  { value: 'kenya', label: 'Kenya' },
  { value: 'ghana', label: 'Ghana' },
  { value: 'colombia', label: 'Colombia' },
  { value: 'chile', label: 'Chile' },
  { value: 'peru', label: 'Peru' },
  { value: 'venezuela', label: 'Venezuela' },
  { value: 'pakistan', label: 'Pakistan' },
  { value: 'bangladesh', label: 'Bangladesh' },
  { value: 'sri_lanka', label: 'Sri Lanka' },
  { value: 'nepal', label: 'Nepal' },
  { value: 'bhutan', label: 'Bhutan' },
  { value: 'maldives', label: 'Maldives' },
  { value: 'iceland', label: 'Iceland' },
  { value: 'luxembourg', label: 'Luxembourg' },
  { value: 'qatar', label: 'Qatar' },
  { value: 'oman', label: 'Oman' },
  { value: 'kuwait', label: 'Kuwait' },
  { value: 'bahrain', label: 'Bahrain' },
  { value: 'iraq', label: 'Iraq' },
  { value: 'iran', label: 'Iran' },
  { value: 'afghanistan', label: 'Afghanistan' },
  { value: 'israel', label: 'Israel' },
  { value: 'jordan', label: 'Jordan' },
  { value: 'lebanon', label: 'Lebanon' },
  { value: 'morocco', label: 'Morocco' },
  { value: 'algeria', label: 'Algeria' },
  { value: 'tunisia', label: 'Tunisia' },
  { value: 'libya', label: 'Libya' },
  { value: 'ethiopia', label: 'Ethiopia' },
  { value: 'tanzania', label: 'Tanzania' },
  { value: 'uganda', label: 'Uganda' },
  { value: 'zimbabwe', label: 'Zimbabwe' },
  { value: 'zambia', label: 'Zambia' },
  { value: 'mozambique', label: 'Mozambique' },
  { value: 'botswana', label: 'Botswana' },
  { value: 'namibia', label: 'Namibia' },
  { value: 'angola', label: 'Angola' },
  { value: 'cuba', label: 'Cuba' },
  { value: 'jamaica', label: 'Jamaica' },
  { value: 'haiti', label: 'Haiti' },
  { value: 'dominican_republic', label: 'Dominican Republic' },
  { value: 'trinidad_and_tobago', label: 'Trinidad and Tobago' },
  { value: 'bahamas', label: 'Bahamas' },
  { value: 'barbados', label: 'Barbados' },
  { value: 'panama', label: 'Panama' },
  { value: 'costa_rica', label: 'Costa Rica' },
  { value: 'honduras', label: 'Honduras' },
  { value: 'guatemala', label: 'Guatemala' },
  { value: 'el_salvador', label: 'El Salvador' },
  { value: 'nicaragua', label: 'Nicaragua' },
  { value: 'belize', label: 'Belize' },
  { value: 'paraguay', label: 'Paraguay' },
  { value: 'uruguay', label: 'Uruguay' },
  { value: 'bolivia', label: 'Bolivia' },
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'guinea', label: 'Guinea' },
  { value: 'ivory_coast', label: 'Ivory Coast' },
  { value: 'cameroon', label: 'Cameroon' },
  { value: 'senegal', label: 'Senegal' },
  { value: 'sudan', label: 'Sudan' },
  { value: 'south_sudan', label: 'South Sudan' },
  { value: 'congo', label: 'Congo' },
  { value: 'madagascar', label: 'Madagascar' },
  { value: 'malawi', label: 'Malawi' },
  { value: 'sierra_leone', label: 'Sierra Leone' },
  { value: 'chad', label: 'Chad' },
  { value: 'mali', label: 'Mali' },
  { value: 'burkina_faso', label: 'Burkina Faso' },
  { value: 'rwanda', label: 'Rwanda' },
  { value: 'burundi', label: 'Burundi' },
  { value: 'lesotho', label: 'Lesotho' },
  { value: 'eswatini', label: 'Eswatini' }

  ];
const countryCodes = ['+1', '+44', '+91', '+81', '+86'];

// Styled Components
const ProfileContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(10),
  marginBottom: theme.spacing(8)
}));

const ProfileCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  backgroundColor: 'var(--artemy-bg-card)',
  border: '1px solid var(--artemy-border)',
  overflow: 'visible',
  position: 'relative',
  boxShadow: 'none',
}));

const ProfileHeader = styled(Box)(({ theme }) => ({
  height: 200,
  background: 'linear-gradient(135deg, rgba(3, 4, 94, 0.4) 0%, rgba(0, 119, 182, 0.2) 100%)',
  borderRadius: '16px 16px 0 0',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  padding: '16px',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '40%',
    background: 'linear-gradient(to top, rgba(8, 9, 13, 0.8), transparent)'
  }
}));

const ProfileAvatarWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: -60,
  transform: 'translateX(-50%)',
  zIndex: 2
}));

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 120,
  height: 120,
  border: `4px solid var(--artemy-bg-card)`,
  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  }
}));



// Add this inside the component

// Update the InfoSection styled component
const InfoSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: 'var(--artemy-bg-elevated)',
  border: '1px solid var(--artemy-border)',
  borderRadius: 12,
  marginBottom: theme.spacing(3)
}));

// Update the StyledTextField component
const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: 'var(--artemy-bg-elevated)',
    color: 'var(--artemy-text-primary)',
    transition: 'all 0.2s ease',
    '& fieldset': {
      borderColor: 'var(--artemy-border)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--artemy-accent)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--artemy-accent)',
    }
  },
  '& .MuiInputLabel-root': {
    color: 'var(--artemy-text-secondary)',
    '&.Mui-focused': {
      color: 'var(--artemy-accent)',
    }
  }
}));

const PhoneInputWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(3)
}));



const CustomerProfile = () => {
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();
const theme = useTheme();
const isDarkMode = theme.palette.mode === 'dark';


    const config = useMemo(() => ({
      bucketName: credentials.bucketName,
      region: credentials.region,
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey
    }), [credentials]);
  
      
        const S3Config = useMemo(() => ({
          bucketName: credentials.bucketName,
          region: credentials.region,
          accessKeyId: credentials.accessKeyId,
          secretAccessKey: credentials.secretAccessKey
        }), [credentials]);
  const token = useAuthToken();
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useSelector(state => state.auth);

  const [state, setState] = useState({
    fname: user.data[0].customer_firstname || '',
    mname: user.data[0].customer_middlename || '',
    lname: user.data[0].customer_lastname || '',
    country: user.data[0].customer_country || '',
    about: user.data[0].about || '',
    email: user.data[0].email || '',
    phone_number: user.data[0].phone_number || '',
    profilePicture: user.data[0].profilePicture || ''
  });

  const [phoneState, setPhoneState] = useState({
    countryCode: state.phone_number ? state.phone_number.slice(0, 3) : '+1',
    number: state.phone_number ? state.phone_number.slice(3) : ''
  });

  const [edit, setEdit] = useState(user.data[0].profile === 0);
  const [image, setImage] = useState('');
  const [uploading, setUploading] = useState(false);
  const [authImage, setAuthImage] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    generatePreSignedUrl();
  }, []);

  const generatePreSignedUrl = async () => {
    if (!state.profilePicture) return;

    try {
      const response = await fetch(process.env.REACT_APP_TALENT_CLOUDFRONTAPI, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: process.env.REACT_APP_CLOUDFRONT + state.profilePicture
        })
      });
      
      const data = await response.json();
      if (data.body) {
        const signedUrl = JSON.parse(data.body).signedUrl;
        setAuthImage(signedUrl);
      }
    } catch (error) {
      console.error("Error generating signed URL:", error);
      setSnackbar({
        open: true,
        message: 'Failed to load profile picture',
        severity: 'error'
      });
    }
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      setSnackbar({
        open: true,
        message: "File size should be less than 5MB",
        severity: "error"
      });
      return;
    }

    setUploading(true);
    try {
      const preview = URL.createObjectURL(file);
      setImage(preview);

      const uploadResult = await S3FileUpload.uploadFile(file, config);
      setState(prev => ({
        ...prev,
        profilePicture: uploadResult.key
      }));

      setSnackbar({
        open: true,
        message: "Profile picture updated successfully",
        severity: "success"
      });
    } catch (error) {
      console.error("Upload error:", error);
      setSnackbar({
        open: true,
        message: "Failed to upload profile picture",
        severity: "error"
      });
      setImage("");
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      const data = {
        customer_id: user.data[0].customer_id,
        customer_firstname: state.fname,
        phone_number: `${phoneState.countryCode}${phoneState.number}`,
        customer_middlename: state.mname,
        customer_lastname: state.lname,
        customer_country: state.country,
        about: state.about,
        profilePicture: state.profilePicture
      };

      await dispatch(CustomerUpdateProfile(data, {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }));

      setSnackbar({
        open: true,
        message: "Profile updated successfully",
        severity: "success"
      });

      setTimeout(() => {
        window.location.href = "/subscriptions";
      }, 1500);
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to update profile",
        severity: "error"
      });
    }
  };

  const handleInputChange = (e) => {
    setState(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };

  return (
    <div className="artemy-fade-up">
      <Container maxWidth="lg" sx={{ mt: 10, mb: 8 }}>
        <Box sx={{ mb: 4 }}>
          <Breadcrumbs 
            separator={<span style={{ color: 'var(--artemy-text-dim)' }}>›</span>} 
            aria-label="breadcrumb"
          >
            <Link 
              to="/subscriptions"
              style={{
                color: 'var(--artemy-accent)',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'var(--artemy-font-mono)',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}
            >
              Subscription
            </Link>
            <Typography 
              sx={{ 
                color: 'var(--artemy-text-dim)', 
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'var(--artemy-font-mono)',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}
            >
              Manage Profile
            </Typography>
          </Breadcrumbs>
        </Box>

      <ProfileCard>
        <ProfileHeader>
          <ProfileAvatarWrapper>
            <ProfileAvatar
              src={image || authImage || defaultimg}
              alt={state.fname}
            />
            {edit && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  opacity: 0,
                  transition: '0.3s',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  '&:hover': { opacity: 1 }
                }}
              >
                <label htmlFor="profile-image">
                  <input
                    accept="image/*"
                    type="file"
                    hidden
                    id="profile-image"
                    onChange={handleImageUpload}
                  />
                  <IconButton 
                    component="span"
                    sx={{ 
                      color: 'white',
                      '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                    }}
                  >
                    <PhotoCameraIcon />
                  </IconButton>
                </label>
              </Box>
            )}
          </ProfileAvatarWrapper>

          {!edit && (
            <IconButton
           sx={{
      position: 'absolute',
      right: 16,
      top: 180,
      backgroundColor: 'var(--artemy-bg-elevated)',
      color: 'var(--artemy-text-primary)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
      border: '1px solid var(--artemy-border)',
      '&:hover': { 
        backgroundColor: 'var(--artemy-bg-card)',
        borderColor: 'var(--artemy-accent)'
      }
    }}
              onClick={() => setEdit(true)}
            >
              <EditIcon />
            </IconButton>
          )}
        </ProfileHeader>

        <CardContent sx={{ pt: 10 }}>
          {edit ? (
  <form onSubmit={handleSubmit}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <StyledTextField
          fullWidth
          label="First Name"
          id="fname"
          value={state.fname}
          onChange={handleInputChange}
          required
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledTextField
          fullWidth
          label="Middle Name"
          id="mname"
          value={state.mname}
          onChange={handleInputChange}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledTextField
          fullWidth
          label="Last Name"
          id="lname"
          value={state.lname}
          onChange={handleInputChange}
          required
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <PhoneInputWrapper>
          <FormControl 
            sx={{ 
              width: '30%',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'var(--artemy-bg-elevated)',
                color: 'var(--artemy-text-primary)',
                '& fieldset': { borderColor: 'var(--artemy-border)' },
                '&:hover fieldset': { borderColor: 'var(--artemy-accent)' },
                '&.Mui-focused fieldset': { borderColor: 'var(--artemy-accent)' }
              },
              '& .MuiInputLabel-root': {
                color: 'var(--artemy-text-secondary)',
                '&.Mui-focused': { color: 'var(--artemy-accent)' }
              }
            }}
          >
            <InputLabel id="country-code-label">Code</InputLabel>
            <Select
              labelId="country-code-label"
              value={phoneState.countryCode}
              onChange={(e) => setPhoneState(prev => ({
                ...prev,
                countryCode: e.target.value
              }))}
              label="Code"
              sx={{
                color: 'var(--artemy-text-primary)'
              }}
            >
              {countryCodes.map(code => (
                <MenuItem 
                  key={code} 
                  value={code}
                  sx={{
                    color: 'var(--artemy-text-primary)',
                    backgroundColor: 'var(--artemy-bg-card)',
                    '&:hover': {
                      backgroundColor: 'var(--artemy-bg-elevated)'
                    },
                    '&.Mui-selected': {
                      backgroundColor: 'var(--artemy-bg-elevated)',
                      fontWeight: 600
                    }
                  }}
                >
                  {code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <StyledTextField
            sx={{ width: '70%' }}
            label="Phone Number"
            value={phoneState.number}
            onChange={(e) => setPhoneState(prev => ({
              ...prev,
              number: e.target.value
            }))}
            required
          />
        </PhoneInputWrapper>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl 
          fullWidth 
          sx={{ 
            mb: 3,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'var(--artemy-bg-elevated)',
              color: 'var(--artemy-text-primary)',
              '& fieldset': { borderColor: 'var(--artemy-border)' },
              '&:hover fieldset': { borderColor: 'var(--artemy-accent)' },
              '&.Mui-focused fieldset': { borderColor: 'var(--artemy-accent)' }
            },
            '& .MuiInputLabel-root': {
              color: 'var(--artemy-text-secondary)',
              '&.Mui-focused': { color: 'var(--artemy-accent)' }
            }
          }}
        >
          <InputLabel>Country</InputLabel>
          <Select
            value={state.country}
            onChange={(e) => setState(prev => ({
              ...prev,
              country: e.target.value
            }))}
            label="Country"
            required
            sx={{
              color: 'var(--artemy-text-primary)'
            }}
          >
            {countries.map(country => (
              <MenuItem 
                key={country.value} 
                value={country.value}
                sx={{
                  color: 'var(--artemy-text-primary)',
                  backgroundColor: 'var(--artemy-bg-card)',
                  '&:hover': {
                    backgroundColor: 'var(--artemy-bg-elevated)'
                  },
                  '&.Mui-selected': {
                    backgroundColor: 'var(--artemy-bg-elevated)',
                    fontWeight: 600
                  }
                }}
              >
                {country.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <StyledTextField
          fullWidth
          multiline
          rows={4}
          label="About"
          id="about"
          value={state.about}
          onChange={handleInputChange}
          required
        />
      </Grid>

      <Grid item xs={12}>
        <StyledTextField
          fullWidth
          label="Email"
          value={state.email}
          disabled
          type="email"
        />
      </Grid>
    </Grid>

    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
      <Button
        variant="outlined"
        onClick={() => setEdit(false)}
        startIcon={<CloseIcon />}
        sx={{
          borderColor: 'var(--artemy-border)',
          color: 'var(--artemy-text-secondary)',
          '&:hover': {
            borderColor: 'var(--artemy-text-secondary)',
            backgroundColor: 'rgba(255, 255, 255, 0.05)'
          }
        }}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        startIcon={<SaveIcon />}
        disabled={uploading}
        sx={{
          backgroundColor: 'var(--artemy-accent) !important',
          color: '#fff !important',
          boxShadow: '0 4px 12px rgba(61, 127, 255, 0.25)',
          '&:hover': { 
            backgroundColor: 'rgba(61, 127, 255, 0.9) !important',
            boxShadow: '0 6px 16px rgba(61, 127, 255, 0.35)',
            transform: 'translateY(-1px)'
          }
        }}
      >
        {uploading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          user.data[0].profile === 0 ? 'Create Profile' : 'Save Changes'
        )}
      </Button>
    </Box>
  </form>
) : (
  <Box>
    <Typography 
      variant="h5" 
      align="center" 
      gutterBottom
      sx={{ color: isDarkMode ? 'grey.100' : 'text.primary' }}
    >
      {`${state.fname} ${state.lname}`}
    </Typography>
    <Typography 
      variant="body1" 
      align="center" 
      sx={{ 
        mb: 4,
        color: isDarkMode ? 'grey.400' : 'text.secondary'
      }}
    >
      {state.email}
    </Typography>
    
    <InfoSection>
      <Typography 
        variant="h6" 
        color="primary" 
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        Basic Information
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PhoneIcon sx={{ color: 'var(--artemy-text-secondary)' }} />
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ color: 'var(--artemy-text-secondary)' }}
              >
                Phone Number
              </Typography>
              <Typography 
                variant="body1"
                sx={{ color: 'var(--artemy-text-primary)' }}
              >
                {state.phone_number}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PublicIcon sx={{ color: 'var(--artemy-text-secondary)' }} />
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ color: 'var(--artemy-text-secondary)' }}
              >
                Country
              </Typography>
              <Typography 
                variant="body1"
                sx={{ color: 'var(--artemy-text-primary)' }}
              >
                {state.country}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <InfoIcon sx={{ 
              mt: 0.5, 
              color: 'var(--artemy-text-secondary)' 
            }} />
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ color: 'var(--artemy-text-secondary)' }}
              >
                About
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  whiteSpace: 'pre-wrap',
                  color: 'var(--artemy-text-primary)'
                }}
              >
                {state.about}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </InfoSection>
  </Box>
)}
        </CardContent>
      </ProfileCard>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          elevation={6}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {uploading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(8, 9, 13, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(8px)'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <CircularProgress size={40} sx={{ color: 'var(--artemy-accent)' }} />
            <Typography sx={{ mt: 2, color: 'var(--artemy-text-primary)', fontWeight: 500 }}>
              Uploading your profile picture...
            </Typography>
          </Box>
        </Box>
      )}
      </Container>
    </div>
  );
};

export default CustomerProfile;